<template>
    <div id="w_post_count_report">
        <div class="col-lg-10 content-title pl-lg-3 mt-1 mb-3">
            <h2 class="content-title">Cikk darabszám</h2>
        </div>
        <ReportFilters :data="data"></ReportFilters>
        <Report :data="data"></Report>
    </div>
</template>

<script>
    import ReportFilters from '../../components/reports/ReportFilters'
    import Report from '../../components/reports/Reports'

    export default{
        name: 'w_post_count_report',
        data() {
            return {
                data: {
                    type: 'post_count',
                    name: 'Cikk darabszám',
                    show_summary: true,
                    path: '/reports/post-count',
                    filters: {
                        date_from: '',
                        date_to: '',
                        user_id: '',
                    }
                }
            }
        },
        components: {
            ReportFilters,
            Report
        }
    }
</script>
